import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const grossIncomeMonthlyFieldOption = {
  registerOptions: {
    deps: 'Frontend/CoApplicantNetIncomeMonthly',
    required: 'error.required',
    valueAsNumber: true,
    min: {
      value: 1_000,
      message: 'GrossIncomeMonthly.error.min',
    },
    max: {
      value: 100_000,
      message: 'GrossIncomeMonthly.error.max',
    },
    validate: {
      isHigherThanNetIncome: (value, form) => {
        if (value <= form['Frontend/CoApplicantNetIncomeMonthly']) {
          return 'GrossIncomeMonthly.error.amount';
        }
      },
    },
  },
  tooltipValidation: {
    message: 'GrossIncomeMonthly.tooltip',
  },
} satisfies IFieldOptions;
